import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

export const initSlider = (container, options = {}) => {
  const sliderElement = container.querySelector('.splide');
  if (!sliderElement) return;

  const splide = new Splide(sliderElement, {
    type: 'slide',
    speed: 1000,
    perMove: 1,
    perPage: 1,
    arrows: false,
    pagination: false,
    updateOnMove: true,
    ...options,
  }).mount();

  const optionsType = splide.options.type;
  const rewindType = splide.options.rewind;

  const slides = container.querySelectorAll('.splide__slide');
  const arrows = container.querySelectorAll('.arrows');
  const progressbar = container.querySelector('.progressbar__thumb');

  const navigationElems = Array.from(arrows).map(arrow => ({
    next: arrow.querySelector('.arrows__next'),
    prev: arrow.querySelector('.arrows__prev'),
    number: arrow.querySelector('.arrows__number'),
  }));

  const progressIndicators = Array.from(slides).map(slide => ({
    current: slide.querySelector('.current__slide'),
    total: slide.querySelector('.total__slide'),
  }));

  const getQuantitySlides = () => splide.Components.Elements.slides.length;
  const getPerPage = () => splide.options.perPage;
  const isLoop = () => splide.options.type === 'loop';

  // Оновлення стрілок і номеру
  function updateNavigation(currentIndex, totalSlides) {
    const isAtStart = splide.index === 0;
    const isAtEnd = splide.index === splide.Components.Controller.getEnd();

    navigationElems.forEach(({ next, prev, number }) => {
      if (next && prev && !rewindType && !isLoop()) {
        next.disabled = isAtEnd;
        prev.disabled = isAtStart;
        next.classList.toggle('is-disabled', isAtEnd);
        prev.classList.toggle('is-disabled', isAtStart);
      }

      if (number) {
        number.textContent = `${String(currentIndex).padStart(2, '0')}/${String(
          totalSlides
        ).padStart(2, '0')}`;
      }
    });
  }

  // Оновлення лічильників всередині слайдів
  function updateSlideCounters() {
    const quantitySlides = getQuantitySlides();

    progressIndicators.forEach(({ current, total }, index) => {
      if (current) {
        current.textContent = String(index + 1).padStart(2, '0');
      }
      if (total) {
        total.textContent = `${String(index + 1).padStart(2, '0')}/${String(
          quantitySlides
        ).padStart(2, '0')}`;
      }
    });
  }

  // Оновлення прогрес-бара
  function updateProgressbar() {
    if (!progressbar) return;

    const quantitySlides = getQuantitySlides();
    const progress =
      (((splide.index + 1) % (quantitySlides + 1)) /
        (quantitySlides + 1 - splide.options.perPage)) *
      100;

    progressbar.style.width = `${progress}%`;
  }

  // Блокування слайдера, якщо слайдів мало
  function handleLockState() {
    const quantitySlides = getQuantitySlides();
    const perPage = getPerPage();
    const shouldLock = quantitySlides <= perPage;

    if (!sliderElement.hasAttribute('data-lock')) return;

    if (shouldLock) {
      splide.Components.Drag.disable(true);
      arrows.forEach(arrow => (arrow.style.display = 'none'));
    } else {
      splide.Components.Drag.mount(true);
      arrows.forEach(arrow => (arrow.style.display = ''));
    }
  }

  // Основна функція оновлення стану слайдера
  function updateSlideState() {
    const quantitySlides = getQuantitySlides();
    const perPage = getPerPage();
    const totalSlides = Math.ceil(quantitySlides / perPage);
    const currentIndex = Math.ceil(splide.index / perPage) + 1;

    updateNavigation(currentIndex, totalSlides);
    updateSlideCounters();
    updateProgressbar();
    handleLockState();
  }

  navigationElems.forEach(({ next, prev }) => {
    next?.addEventListener('click', () => splide.go('>'));
    prev?.addEventListener('click', () => splide.go('<'));
  });

  const eventToUse = optionsType === 'fade' ? 'moved' : 'move';
  splide.on(eventToUse, updateSlideState);

  updateSlideState();
  window.addEventListener('resize', updateSlideState);

  return splide;
};
